import { render } from "./ContentOptimisationTableNewWithParents.vue?vue&type=template&id=2cfddb96&scoped=true"
import script from "./ContentOptimisationTableNewWithParents.vue?vue&type=script&lang=js"
export * from "./ContentOptimisationTableNewWithParents.vue?vue&type=script&lang=js"

import "./ContentOptimisationTableNewWithParents.vue?vue&type=style&index=0&id=2cfddb96&lang=scss"
import "./ContentOptimisationTableNewWithParents.vue?vue&type=style&index=1&id=2cfddb96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfddb96"]])

export default __exports__